import { render, staticRenderFns } from "./TaxGroups.vue?vue&type=template&id=d2b9d8ac&scoped=true"
import script from "./TaxGroups.vue?vue&type=script&lang=js"
export * from "./TaxGroups.vue?vue&type=script&lang=js"
import style0 from "./TaxGroups.vue?vue&type=style&index=0&id=d2b9d8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b9d8ac",
  null
  
)

export default component.exports